import React, { Component, useRef } from "react";
import ReactToPrint from "react-to-print";
import { Button } from "react-bootstrap";
import { FileEarmarkText } from "react-bootstrap-icons";
import Swal from "sweetalert2";

import PDFOrderHeader from "./pdf-order-header";
import PDFOrderDados from "./pdf-order-dados";
import PDFOrderEspecificacao from "./pdf-order-especificacao";
import PDFOrderPrescricao from "./pdf-order-prescricao";
import PDFOrderArmacao from "./pdf-order-armacao";
import PDFOrderFooter from "./pdf-order-footer";

//Import CSS
import "./pdf-order.css";
import AppContext from "../../appContext";
import ServicesUtils from "../../shared/utils/ServicesUtils";
import { PROMO_SEARCH_TERMS, PROMOCAO_TYPES, VOUCHER_PREFIX } from "./constant/promo-types";
import { resolverParDoPedido } from "../../Functions/voucher/par-do-pedido";

class PDFOrder extends Component {
  constructor(props) {
    super(props);

    this.state = {
      id: "",
      order: null,
      header: null,
      dados: null,
      especificacao: null,
      prescricao: null,
      armacao: null,
      footer: null,
      hasDireito: false,
      hasEsquerdo: false,
      empresa_faturamento: "",
      empresa_faturamento_cnpj: "",
      voucherParesQtd: null,
    };

    PDFOrder.contextType = AppContext;
  }

  async componentDidMount() {
    this.setState({
      isLabOG: this.props.isLabOG,
      isPedidoPromocional: this.props.isPedidoPromocional
    })
  }

  reactToPrintTrigger = () => {
    const { label, btn_class, icon, customIcon } = this.props;

    return (
      <Button className={btn_class ? btn_class : "pdf-button"} variant="link">
        {customIcon ? customIcon : (icon && <FileEarmarkText size={16} className="me-1" />)}
        {label ? label : "Visualizar Pedido"}
      </Button>
    );
  };

  handleOnBeforeGetContent = () => {
    const { laboratorio, otica, pedido_laboratotio, redeOticas, local, rastreabilidade } = this.props;

    this.context.showLoading("");

    var header = {};
    if (redeOticas || local === "tracking" || rastreabilidade) {
      header = {
        client_id: localStorage.getItem("clientid"),
        access_token: sessionStorage.getItem("token"),
        laboratorio: laboratorio,
        otica: otica,
      };
    } else {
      header = {
        client_id: localStorage.getItem("clientid"),
        access_token: sessionStorage.getItem("token"),
        laboratorio: laboratorio,
      };
    }

    return new Promise((resolve: any) => {
      const requestOptions = {
        method: "GET",
        headers: header,
      };

      fetch(process.env.REACT_APP_ESSILOR_API + "gestao-pedidos-laboratorio/v1/pedidos/" + pedido_laboratotio, requestOptions)
        .then(response => {
          if (response.status === 200) {
            return response.json();
          } else {
            this.context.hideLoading();
            Swal.fire({
              html: "Erro ao tentar recuperar as informações do pedido. Tente novamente mais tarde.<br><br>Em caso de dúvidas, entre em contato com o laboratório.",
              icon: "warning",
              title: "Aviso",
              confirmButtonColor: "#00518b",
              customClass: {
                confirmButton: "x-follow-order__filter-btn",
              },
            });
          }
        })
        .then(async json => {
          let tipoArmacaoDominio = null;
          const codigoLinhaProduto = json?.receita?.olhoDireito?.codigoLinhaProduto
            || json?.receita?.olhoEsquerdo?.codigoLinhaProduto;

          if (codigoLinhaProduto) {
            tipoArmacaoDominio = await this.fetchTipoArmacaoDominio(codigoLinhaProduto);
          }

          let armacao = await this.setArmacao(json, tipoArmacaoDominio);
          if (json) {
            if (json.hasOwnProperty("codigo")) {
              this.context.hideLoading();
              Swal.fire({
                html: json.mensagem +
                  '<br><br>Em caso de dúvidas, entre em contato com o laboratório.',
                icon: "error",
                title: "Aviso",
                confirmButtonColor: "#00518b",
                customClass: {
                  confirmButton: "x-follow-order__filter-btn",
                },
              });
            } else {
              this.getEmpresaFaturamento(async () => {
                const { parInfo, paresQtd } = await resolverParDoPedido(json);

                this.setState(
                  {
                    header: this.setHeader(json),
                    dados: this.setDados(json, parInfo),
                    especificacao: this.setEspecificacao(json),
                    prescricao: this.setPrescricao(json),
                    armacao: armacao,
                    footer: this.setFooter(json),
                    order: json,
                    voucherParesQtd: paresQtd,
                  },
                  () => {
                    resolve();
                  },
                );
                this.context.hideLoading();
              });
            }
          }
        });
    });
  };

  async fetchTipoArmacaoDominio(codigoLinhaProduto) {
    try {
      const { laboratorio, otica, redeOticas, local, rastreabilidade } = this.props;

      var headers = {
        access_token: sessionStorage.getItem("token"),
        laboratorio: laboratorio,
      };

      if (redeOticas || local === "tracking" || rastreabilidade) {
        headers.otica = otica;
      }

      const requestOptions = {
        method: "GET",
        headers: headers,
      };

      const response = await fetch(
        process.env.REACT_APP_ESSILOR_API +
        "gestao-produtos-laboratorio/v1/produtos/" + codigoLinhaProduto + "/parametros",
        requestOptions
      );

      if (response.status === 200) {
        const json = await response.json();
        return json?.armacao?.tipo?.dominio || null;
      }
      return null;
    } catch (error) {
      return null;
    }
  }

  getEmpresaFaturamento = callback => {
    const { otica } = this.props;
    const requestOptions1 = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ cnpj: otica ? otica : this.context.userSession.conta }),
    };

    fetch(process.env.REACT_APP_LABS_API + "get_account_data.php", requestOptions1)
      .then(response => {
        return response.json();
      })
      .then(json => {
        this.setState(
          {
            empresa_faturamento: json.nome,
            empresa_faturamento_cnpj: json.cnpj,
          },
          callback,
        );
      });
  };

  setValueOrder(json) {
    var order = {};
    order.valorLiquido = "";

    return order;
  }

  setHeader(json) {
    const { isLabOG } = this.props;

    return {
      pedido: isLabOG
        ? (json.idPedidoOpticlick || json.idPedidoOtica || json.id)
        : json.id,
      idPedidoOpticlick: json.idPedidoOpticlick,
      laboratorio: this.props.laboratorio_nome,
      valor_pedido: json.orcamento?.valorLiquido || false,
    };
  }

  setDados(json, parInfo = "") {
    let promoName = "";

    if (this.props.promotionName) {
      promoName = this.props.promotionName;
    } else if (json?.promocao && json?.promocao?.campanha && json?.promocao?.campanha?.nome) {
      promoName = json.promocao.campanha.nome;

      if (promoName.includes(PROMO_SEARCH_TERMS.DOSE_DUPLA_KODAK) ||
        (json.promocao.voucher &&
          json.promocao.voucher.startsWith(VOUCHER_PREFIX.KODAK_PREFIX) &&
          promoName.includes("KODAK"))
      ) {
        promoName = PROMOCAO_TYPES.DOSE_DUPLA_KODAK;
      } else if (promoName.includes(PROMO_SEARCH_TERMS.VARILUX) &&
        promoName.includes(PROMO_SEARCH_TERMS.DOBRO)
      ) {
        promoName = PROMOCAO_TYPES.VARILUX_DOBRO;
      } else if (promoName.includes(PROMO_SEARCH_TERMS.CRIZAL) &&
        promoName.includes(PROMO_SEARCH_TERMS.DOBRO)
      ) {
        promoName = PROMOCAO_TYPES.CRIZAL_DOBRO;
      }
    } else if (json?.promocaoLaboratorio && json?.promocaoLaboratorio?.descricao) {
      promoName = json.promocaoLaboratorio.descricao;
    }

    const isPromocaoEmDobro = promoName && (
      (promoName.toUpperCase().includes("VARILUX") && promoName.toUpperCase().includes("DOBRO")) ||
      (promoName.toUpperCase().includes("CRIZAL") && promoName.toUpperCase().includes("DOBRO")) ||
      promoName.toUpperCase().includes("DOSE DUPLA KODAK")
    );

    if (parInfo && promoName && isPromocaoEmDobro) {
      promoName = `${promoName} ${parInfo}`;
    }

    return {
      numero_pedido: json?.idPedidoOtica,
      nome_cliente: json?.hasOwnProperty("paciente") && json?.paciente ? json?.paciente?.nome : "",
      nome_medico: json?.hasOwnProperty("medico") && json?.medico ? json?.medico?.nome : "",
      cpf_cliente: json?.hasOwnProperty("paciente") && json?.paciente ? json?.paciente?.cpf : "",
      crm_medico: json?.hasOwnProperty("medico") && json?.medico ? json?.medico?.crm : "",
      codigo_participante: json?.programaLaboratorio?.codigoParticipante || "",
      empresa_faturamento: this.state.empresa_faturamento,
      promo_code: json?.promocao && json?.promocao.hasOwnProperty("voucher") ? json?.promocao?.voucher : "",
      dados_promo_nome: promoName,
      dados_promo_pedido_origem: this.props.pedidoOrigemPromocao || json?.promocaoLaboratorio?.idPedido || "",
    };
  }

  setEspecificacao(json) {
    var servico, corte, coloracao;

    if (json?.hasOwnProperty("servicos")) {
      json.servicos.map((item, index) => {
        if (item?.tipo === "MONTAGEM") {
          corte = item?.descricao;
        }

        if (item?.tipo === "COLORACAO") {
          coloracao = item?.descricao;
        }
      });

      const antirreflexoPreferido = ServicesUtils.getAntirreflexoPreferido(json.servicos);
      if (antirreflexoPreferido) {
        servico = antirreflexoPreferido.descricao;
      }
    }

    var tipo_producao = "";
    var tipo_produto = "";
    var tipo_producaoAux = "";
    var tipo_produtoAux = "";

    const { isLabOG } = this.props;
    this.setState({
      id: isLabOG
        ? (json.idPedidoOpticlick || json.idPedidoOtica || json.id)
        : json.id
    });
    if (json?.receita) {
      if (json?.receita?.hasOwnProperty("olhoDireito")) {
        tipo_producaoAux = json?.receita?.olhoDireito?.tipoProducao;
        tipo_produtoAux = json?.receita?.olhoDireito?.tipoProduto;
      } else if (json?.receita?.hasOwnProperty("olhoDireito")) {
        tipo_producaoAux = json?.receita?.olhoEsquerdo?.tipoProducao;
        tipo_produtoAux = json?.receita?.olhoEsquerdo?.tipoProduto;
      }
    }

    switch (tipo_producaoAux) {
      case "SURFACAGEM_DIGITAL":
        tipo_producao = "Surfaçagem Digital";
        break;
      case "SURFACAGEM_TRADICIONAL":
        tipo_producao = "Surfaçagem Tradicional";
        break;
      case "LENTES_PRONTA":
        tipo_producao = "Lente Pronta";
        break;
      default:
        break;
    }

    switch (tipo_produtoAux) {
      case "BIFOCAL":
        tipo_produto = "Bifocal";
        break;
      case "MULTIFOCAL":
        tipo_produto = "Multifocal";
        break;
      case "VISAO_SIMPLES":
        tipo_produto = "Visão Simples";
        break;
      case "VISAO_INTERMEDIARIA":
        tipo_produto = "Visão Intermediária";
        break;
      default:
        break;
    }

    return {
      tipo_producao: tipo_producao,
      tipo_produto: tipo_produto,
      produto_escolhido: json?.receita ? (json?.receita?.olhoDireito?.produto ? json?.receita?.olhoDireito?.produto : json?.receita?.olhoEsquerdo?.produto) : "",
      servico: servico,
      coloracao: coloracao,
      corte_montagem: corte,
      cor: json.corColoracao ? (json?.corColoracao?.descricao ? json?.corColoracao?.descricao : "") : "",
    };
  }

  setPrescricao(json) {
    var response = {
      receita: {
        direito: null,
        esquerdo: null,
      },
      prisma: {
        direito: null,
        esquerdo: null,
      },
      medidas: {
        direito: null,
        esquerdo: null,
      },
      personalizadas: this.setPersonalizados(json),
    };

    if (json?.receita && json?.receita?.hasOwnProperty("olhoDireito")) {
      if (json?.receita?.olhoDireito?.codigoLinhaProduto || json?.receita?.olhoDireito?.grauEsferico || json?.receita?.olhoDireito?.rpl) {
        this.setState({
          hasDireito: true,
        });
      }

      var receitaDireito = {
        esferico: json?.receita?.olhoDireito?.grauEsferico,
        cilindrico: json?.receita?.olhoDireito?.grauCilindro === "0.00" ? "" : json?.receita?.olhoDireito?.grauCilindro,
        eixo: json?.receita?.olhoDireito?.eixo,
        adicao: json?.receita?.olhoDireito?.adicao,
      };

      var prismaDireito = {
        horizontal: json?.receita?.olhoDireito?.valorPrismaHorizontal,
        base_horizontal: json?.receita?.olhoDireito?.eixoPrismaHorizontal,
        vertical: json?.receita?.olhoDireito?.valorPrismaVertical,
        base_vertical: json?.receita?.olhoDireito?.eixoPrismaVertical,
      };

      var medidaDireito = {
        dnp: json?.receita?.olhoDireito?.dnp,
        altura: json?.receita?.olhoDireito?.altura,
        dnp_perto: json?.hasOwnProperty("parametros") && json?.parametros ? json?.parametros?.olhoDireito?.dnpPerto : "",
        cro: json?.hasOwnProperty("parametros") && json?.parametros ? json?.parametros?.olhoDireito?.cro : "",
        vertice: json?.hasOwnProperty("parametros") && json?.parametros ? json?.parametros?.olhoDireito?.distanciaVertice : "",
        et: json?.receita?.olhoDireito?.et,
        ct: json?.receita?.olhoDireito?.ct,
        base: json?.receita?.olhoDireito?.base,
      };

      response.receita.direito = receitaDireito;
      response.prisma.direito = prismaDireito;
      response.medidas.direito = medidaDireito;
    }

    if (json?.receita && json?.receita?.hasOwnProperty("olhoEsquerdo")) {
      if (json?.receita?.olhoEsquerdo?.codigoLinhaProduto || json?.receita?.olhoEsquerdo?.grauEsferico || json?.receita?.olhoEsquerdo?.rpl) {
        this.setState({
          hasEsquerdo: true,
        });
      }

      var receitaEsquerdo = {
        esferico: json?.receita?.olhoEsquerdo?.grauEsferico,
        cilindrico: json?.receita?.olhoEsquerdo?.grauCilindro === "0.00" ? "" : json?.receita?.olhoEsquerdo?.grauCilindro,
        eixo: json?.receita?.olhoEsquerdo?.eixo,
        adicao: json?.receita?.olhoEsquerdo?.adicao,
      };

      var prismaEsquerdo = {
        horizontal: json?.receita?.olhoEsquerdo?.valorPrismaHorizontal,
        base_horizontal: json?.receita?.olhoEsquerdo?.eixoPrismaHorizontal,
        vertical: json?.receita?.olhoEsquerdo?.valorPrismaVertical,
        base_vertical: json?.receita?.olhoEsquerdo?.eixoPrismaVertical,
      };

      var medidaEsquerdo = {
        dnp: json?.receita?.olhoEsquerdo?.dnp,
        altura: json?.receita?.olhoEsquerdo?.altura,
        dnp_perto: json?.hasOwnProperty("parametros") && json?.parametros ? json?.parametros?.olhoEsquerdo?.dnpPerto : "",
        cro: json?.hasOwnProperty("parametros") && json?.parametros ? json?.parametros?.olhoEsquerdo?.cro : "",
        vertice: json?.hasOwnProperty("parametros") && json?.parametros ? json?.parametros?.olhoEsquerdo?.distanciaVertice : "",
        et: json?.receita?.olhoEsquerdo?.et,
        ct: json?.receita?.olhoEsquerdo?.ct,
        base: json?.receita?.olhoEsquerdo?.base,
      };

      response.receita.esquerdo = receitaEsquerdo;
      response.prisma.esquerdo = prismaEsquerdo;
      response.medidas.esquerdo = medidaEsquerdo;
    }

    return response;
  }

  setPersonalizados(json) {
    var response = {
      iniciais_cliente: json?.hasOwnProperty("paciente") && json?.paciente ? json?.paciente?.iniciaisPaciente : "",
      distancia_leitura: "",
      cvp: "",
      pantoscopico: "",
      curvatura: "",
      coeficiente: "",
      estabilidade: "",
      progressao: "",
      olho_dominante: json?.hasOwnProperty("parametros") && json?.parametros ? json?.parametros?.olhoDominante : "",
    };

    if (json?.hasOwnProperty("parametros") && json?.parametros) {
      if (json?.parametros?.hasOwnProperty("olhoDireito")) {
        response.distancia_leitura = json?.parametros?.olhoDireito?.distanciaLeitura;
        response.cvp = json?.parametros?.olhoDireito?.cvp;
        response.pantoscopico = json?.parametros?.olhoDireito?.anguloPantoscopico;
        response.curvatura = json?.parametros?.olhoDireito?.anguloCurvatura;
        response.coeficiente = json?.parametros?.olhoDireito?.coeficienteHE;
        response.estabilidade = json?.parametros?.olhoDireito?.coeficienteST;
        response.progressao = json?.parametros?.olhoDireito?.distanciaProgressao;
      } else if (json?.parametros?.hasOwnProperty("olhoEsquerdo")) {
        response.distancia_leitura = json?.parametros?.olhoEsquerdo?.distanciaLeitura;
        response.cvp = json?.parametros?.olhoEsquerdo?.cvp;
        response.pantoscopico = json?.parametros?.olhoEsquerdo?.anguloPantoscopico;
        response.curvatura = json?.parametros?.olhoEsquerdo?.anguloCurvatura;
        response.coeficiente = json?.parametros?.olhoEsquerdo?.coeficienteHE;
        response.estabilidade = json?.parametros?.olhoEsquerdo?.coeficienteST;
        response.progressao = json?.parametros?.olhoEsquerdo?.distanciaProgressao;
      }
    }

    return response;
  }

  async setArmacao(json, tipoArmacaoDominio) {
    var response = null;

    var tipo_armacao = "";

    if (json?.armacao && json.armacao?.tipo) {
      if (tipoArmacaoDominio && tipoArmacaoDominio.length > 0) {
        const tipoEncontrado = tipoArmacaoDominio.find(
          item => String(item.codigo) === String(json.armacao.tipo)
        );
        if (tipoEncontrado) {
          tipo_armacao = tipoEncontrado.descricao;
        }
      }

      if (!tipo_armacao) {
        switch (parseInt(json.armacao?.tipo)) {
          case 1:
            tipo_armacao = "METAL";
            break;
          case 2:
            tipo_armacao = "ACETATO";
            break;
          case 3:
            tipo_armacao = "PARAFUSO";
            break;
          case 4:
            tipo_armacao = "NYLON";
            break;
          case 5:
            tipo_armacao = "SEG METAL";
            break;
          case 6:
            tipo_armacao = "SEG ACETATO";
            break;
          case 7:
            tipo_armacao = "FIO DE AÇO";
            break;
          default:
            break;
        }
      }
    }

    if (json?.hasOwnProperty("armacao") && json?.armacao) {
      const { isLabOG } = this.props;

      let cor = null;
      if (isLabOG) {
        if (json.armacao?.descricaoCor) {
          cor = { descricao: json.armacao.descricaoCor };
        } else if (json.armacao?.cor && typeof json.armacao.cor === 'string') {
          cor = { descricao: json.armacao.cor };
        } else {
          cor = json.armacao?.cor || null;
        }
      } else {
        cor = json.armacao?.cor || null;
      }

      response = {
        tipo_armacao: tipo_armacao,
        modelo_armacao: json.armacao?.modelo,
        referencia_armacao: json.armacao?.referencia,
        observacao: json?.observacao,
        vertical: json.armacao?.vertical,
        horizontal: json.armacao?.horizontal,
        diagonal_maior: json.armacao?.diametroMaior,
        ponte: json.armacao?.ponte,
        cor: cor,
        marca: json.armacao?.marca || "",
      };
    }

    return response;
  }

  setFooter(json) {
    const { prazo, laboratorio_nome, isLabOG } = this.props;

    return {
      pedido: isLabOG
        ? (json.idPedidoOpticlick || json.idPedidoOtica || json.id)
        : json.id,
      idPedidoOpticlick: json.idPedidoOpticlick,
      laboratorio: laboratorio_nome,
      prazo: prazo,
    };
  }

  render() {
    return (
      <>
        <ReactToPrint
          documentTitle={`Essilor Conecta - Pedido ${this.state.id}`}
          onBeforeGetContent={this.handleOnBeforeGetContent}
          trigger={this.reactToPrintTrigger}
          content={() => this.componentRef}
        />

        <div style={{ display: "none" }}>
          {this.state.order && (
            <div className="pdf-order container" ref={el => (this.componentRef = el)}>
              <PDFOrderHeader dados={this.state.header} isLabOG={this.state.isLabOG} isPedidoPromocional={this.state.isPedidoPromocional}></PDFOrderHeader>
              <PDFOrderDados dados={this.state.dados}></PDFOrderDados>
              <PDFOrderEspecificacao especificacao={this.state.especificacao}></PDFOrderEspecificacao>
              <PDFOrderPrescricao
                prescricao={this.state.prescricao}
                hasOlhoDireito={this.state.hasDireito}
                hasOlhoEsquerdo={this.state.hasEsquerdo}></PDFOrderPrescricao>
              <PDFOrderArmacao armacao={this.state.armacao}></PDFOrderArmacao>
              <PDFOrderFooter footer={this.state.footer} isLabOG={this.state.isLabOG} isPedidoPromocional={this.state.isPedidoPromocional}></PDFOrderFooter>
            </div>
          )}
        </div>
      </>
    );
  }
}

export default PDFOrder;
